import useShopProductDetails from 'hooks/useShopProductDetails';
import getApiError from 'services/getApiError';
import { getTeacher } from 'services/teacher';
import useSWR from 'swr';

interface UseWorkshopDetailsOption {
  publisherSlug: string;
  productId: string;
}

export const usePublisherDetails = (slug: string) => {
  const { data, error, isValidating } = useSWR(
    slug ? `workshop/publisher_details/${slug}` : null,
    () => (slug ? getTeacher(slug) : null),
    {
      shouldRetryOnError: false
    }
  );
  const isLoading = isValidating && !error && !data;

  return { publisherDetails: data, error, isLoading };
};

const useWorkshopDetails = (option: UseWorkshopDetailsOption) => {
  const { publisherSlug, productId } = option;
  const {
    publisherDetails,
    isLoading: isPublisherLoading,
    error: publisherFetchError
  } = usePublisherDetails(publisherSlug);
  const {
    shopProduct: workshopDetails,
    isFetchingShopProductDetails,
    error: workshopFetchError
  } = useShopProductDetails({ shopProductId: productId });
  const error = publisherFetchError || workshopFetchError;
  const isLoading = isPublisherLoading || isFetchingShopProductDetails;

  return {
    workshopDetails,
    error: getApiError(error),
    isLoading,
    publisherDetails
  };
};

export default useWorkshopDetails;
